<template>
  <div class="draggable" :class="{ active: isActive }" draggable="false" @mousedown="onStartMove" @touchstart="onStartMove" @click.capture="cancelClick" :style="{
    transform: `translate(${currentX}px, ${currentY}px) rotate(${currentAngle}deg) scale(${scale || 1.0})`,
    width: width,
    height: height,
    zIndex: zIndex
  }">
    <slot></slot>

    <div v-if="!lock && resizable" class="bar t" @mousedown.stop="onStartRotate"></div>
    <div v-if="!lock && resizable" class="bar l" @mousedown.stop="onStartRotate"></div>
    <div v-if="!lock && resizable" class="bar r" @mousedown.stop="onStartRotate"></div>
    <div v-if="!lock && resizable" class="bar b" @mousedown.stop="onStartRotate"></div>
    <div v-if="!lock && resizable" class="point tl" @mousedown.stop="onStartRotate"></div>
    <div v-if="!lock && resizable" class="point tr" @mousedown.stop="onStartRotate"></div>
    <div v-if="!lock && resizable" class="point bl" @mousedown.stop="onStartRotate"></div>
    <div v-if="!lock && resizable" class="point br" @mousedown.stop="onStartResize"></div>
    <!-- <faicon icon="expand-arrows-alt" v-if="!lock && resizable" class="point br" @mousedown.stop="onStartResize" /> -->
  </div>
</template>

<script>
export default {
  props: {
    x: Number,
    y: Number,
    z: Number,
    w: Number,
    h: Number,
    scale: Number,
    angle: Number,
    resizable: Boolean,
    ratio: Number,
    lock: Boolean,
    disableX: Boolean,
    disableY: Boolean
  },
  data() {
    return {
      currentX: this.$props.x,
      currentY: this.$props.y,
      currentZ: this.$props.z,
      currentW: this.$props.w || null,
      currentH: this.$props.h || null,
      currentAngle: this.$props.angle || 0,
      startX: 0,
      startY: 0,
      startW: 0,
      startH: 0,
      offsetX: 0,
      offsetY: 0,
      startAngle: 0,
      touchX: 0,
      touchY: 0,
      isDragging: false,
      isResizing: false,
      isRolling: false,
      isChanged: false,
      isNotClick: false
    }
  },
  watch: {
    x(newProp) {
      if (!this.isActive) {
        this.$data.currentX = newProp
      }
    },
    y(newProp) {
      if (!this.isActive) {
        this.$data.currentY = newProp
      }
    },
    w(newProp) {
      if (!this.isActive) {
        this.$data.currentW = newProp
      }
    },
    h(newProp) {
      if (!this.isActive) {
        this.$data.currentH = newProp
      }
    },
    z(newProp) {
      if (!this.isActive) {
        this.$data.currentZ = newProp
      }
    },
    angle(newProp) {
      if (!this.isActive) {
        this.$data.currentAngle = newProp
      }
    }
  },
  computed: {
    zIndex() {
      const { currentZ } = this.$data

      if (!this.$props.resizable && currentZ === undefined) return null
      if (currentZ !== undefined) return 10000 + ~~currentZ

      const { currentW, currentH } = this.$data
      return (this.$props.lock ? 10000 : 10000) - (~~(currentW * 0.1) + ~~(currentH * 0.1))
    },
    width() {
      const { currentW } = this.$data
      if (!currentW) return null
      return typeof currentW === 'number' ? currentW + 'px' : currentW
    },
    height() {
      const { currentH } = this.$data
      if (!currentH) return null
      return typeof currentH === 'number' ? currentH + 'px' : currentH
    },
    isActive() {
      return this.$data.isDragging || this.$data.isResizing || this.$data.isRolling
    },
  },
  mounted() {
    const { currentW, currentH } = this.$data
    if (!this.$props.resizable) {
      this.$data.currentW = currentW === 'auto' ? ~~this.$el.offsetWidth : ~~currentW
      this.$data.currentH = currentH === 'auto' ? ~~this.$el.offsetHeight : ~~currentH
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    this.disable()
  },
  methods: {
    onStart(e) {
      const { currentX, currentY, currentW, currentH, currentAngle } = this.$data
      // const ratio = this.$props.ratio || 1
      this.$data.startX = ~~currentX
      this.$data.startY = ~~currentY
      this.$data.startW = ~~currentW
      this.$data.startH = ~~currentH
      this.$data.startAngle = ~~currentAngle
      this.$data.touchX = e.clientX || e.touches[0].clientX
      this.$data.touchY = e.clientY || e.touches[0].clientY
      this.$data.centerX = ~~(this.$el.getBoundingClientRect().left * 2 + this.$el.getBoundingClientRect().width) * 0.5
      this.$data.centerY = ~~(this.$el.getBoundingClientRect().top * 2 + this.$el.getBoundingClientRect().height) * 0.5
      this.$data.isChanged = false
      this.$data.isNotClick = false
    },
    onStartMove(e) {
      if (!this.$props.lock) {
        e.stopPropagation()
        this.onStart(e)
        this.$data.isDragging = true
        this.enable()
        this.tick()
      }
    },
    onStartResize(e) {
      if (!this.$props.lock) {
        this.onStart(e)
        this.$data.isResizing = true
        this.enable()
        this.tick()
      }
    },
    onStartRotate(e) {
      if (!this.$props.lock) {
        this.onStart(e)
        this.$data.isRolling = true
        this.enable()
        this.tick()
      }
    },
    onMove(e) {
      const { isDragging, isResizing, isRolling } = this.$data
      const { disableX, disableY } = this.$props
      if (isDragging || isResizing || isRolling) {
        const ratio = this.$props.ratio || 1
        const {
          touchX,
          touchY,
          startX,
          startY,
          startW,
          startH,
          startAngle,
          // currentW,
          // currentH,
          // currentX,
          // currentY,
          centerX,
          centerY
        } = this.$data
        const clientX = e.clientX || e.touches[0].clientX
        const clientY = e.clientY || e.touches[0].clientY
        // console.log(clientX, clientY);

        const diffX = clientX / ratio - touchX / ratio
        const diffY = clientY / ratio - touchY / ratio
        if (isDragging) {
          if (!disableX) {
            this.$data.currentX = startX + diffX
          } else {
            this.$data.currentX = 0
          }
          if (!disableY) {
            this.$data.currentY = startY + diffY
          } else {
            this.$data.currentY = 0
          }
        }
        if (isResizing) {
          this.$data.currentW = startW + diffX
          this.$data.currentH = startH + diffY
        }
        if (isRolling) {
          const ba = [touchX - centerX, touchY - centerY]
          const bc = [clientX - centerX, clientY - centerY]

          // C.style.left = e.clientX + 'px'
          // C.style.top = e.clientY + 'px'
          // B.style.left = centerX + 'px'
          // B.style.top = centerY + 'px'
          // A.style.left = touchX + 'px'
          // A.style.top = touchY + 'px'

          const babc = ba[0] * bc[0] + ba[1] * bc[1]
          const ban = (ba[0] * ba[0]) + (ba[1] * ba[1])
          const bcn = (bc[0] * bc[0]) + (bc[1] * bc[1])
          const radian = Math.acos(babc / (Math.sqrt(ban * bcn)))
          const angle = Math.round(radian * 180 / Math.PI * 0.1) * 10
          if (ba[0] * bc[1] - ba[1] * bc[0] > 0) {
            this.$data.currentAngle = startAngle + angle
          } else {
            this.$data.currentAngle = startAngle + 360 - angle
          }
        }
        this.$data.isChanged = true
        this.$data.isNotClick = Math.abs(diffX) >= 5
        this.tick()
        // e.preventDefault()
      }
    },
    onEnd() {
      const { currentX, currentY, currentW, currentH, currentAngle, isChanged } = this.$data
      this.disable()
      if (isChanged) this.$emit('change', currentX, currentY, currentW, currentH, currentAngle)
    },
    cancelClick(e) {
      const { isNotClick } = this.$data
      if (isNotClick) {
        e.preventDefault()
        e.stopPropagation()
      }
    },
    tick() {
      clearTimeout(this.timer)
      this.timer = setTimeout(this.disable, 1500)
    },
    enable() {
      if (window) {
        window.addEventListener('mousemove', this.onMove)
        window.addEventListener('mouseup', this.onEnd)
        window.addEventListener('touchmove', this.onMove)
        window.addEventListener('touchend', this.onEnd)
      }
    },
    disable() {
      this.$data.isDragging = false
      this.$data.isResizing = false
      this.$data.isRolling = false
      if (window) {
        window.removeEventListener('mousemove', this.onMove)
        window.removeEventListener('mouseup', this.onEnd)
        window.removeEventListener('touchmove', this.onMove)
        window.removeEventListener('touchend', this.onEnd)
      }
    }
  }
}
</script>
<style scoped>
.draggable {
  user-select: none;
  position: absolute;
  transition: all 300ms ease-out; /* [!] */
}
.draggable * {
  user-select: none;
}
.draggable.active {
  transition: none;
/*  outline: 2px solid #222;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.4);*/
}
.bar {
  position: absolute;
  cursor: crosshair;
  background: rgba(0, 0, 0, 0.4);
  /* opacity: 0; */
}
.bar.t {
  top: -10px;
  left: 0;
  right: 0;
  width: 100%;
  height: 10px;
}
.bar.b {
  bottom: -10px;
  left: 0;
  right: 0;
  width: 100%;
  height: 10px;
}
.bar.l {
  top: 0;
  bottom: 0;
  left: -10px;
  width: 10px;
  height: 100%;
}
.bar.r {
  top: 0;
  bottom: 0;
  right: -10px;
  width: 10px;
  height: 100%;
}
.point {
  position: absolute;
  cursor: crosshair;
  background: rgba(0, 0, 0, 0.4);
  /* opacity: 0; */
  color: #fff;
}
.point.tl {
  top: -10px;
  left: -10px;
  width: 10px;
  height: 10px;
}
.point.tr {
  top: -10px;
  right: -10px;
  width: 10px;
  height: 10px;
}
.point.bl {
  bottom: -10px;
  left: -10px;
  width: 10px;
  height: 10px;
}
.point.br {
  bottom: -10px;
  right: -10px;
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.8);
  cursor: se-resize;
}
.draggable:hover > .bar,
.draggable:hover > .point {
  opacity: 1;
}
.draggable.active > .bar,
.draggable.active > .point {
  opacity: 0;
}
</style>
